import React, {useEffect} from "react";
import {Box} from "@mui/material";
import {organizationActions, payoutsActions, pricingActions, scheduleActions} from "../../../../../_actions";
import {Loading} from "../../../../common";
import {useDispatch, useSelector} from "react-redux";
import {useParams} from "react-router-dom";
import EditScheduleForm from "./EditScheduleForm";
import {queryStringToObject} from "../../../../../_helpers";

export default function AdminEditSchedule() {
    const dispatch = useDispatch()
    const params = useParams();
    const {scheduleId} = params;
    const search = window.location.search.substring(1);
    const urlParams =  queryStringToObject(search);
    const organizationId = urlParams.organization

    const currentSchedule = useSelector((state) => state.schedules.current)
    const currentScheduleLoading = useSelector((state) => state.schedules.loading)
    const payoutRates = useSelector((state) => state.payout.all_payouts)
    const pricingRates = useSelector((state) => state.pricing.all_pricing)
    const payoutRatesLoading = useSelector((state) => state.payout.loading)
    const pricingRatesLoading = useSelector((state) => state.pricing.loading)
    const organization = useSelector(state => state.organizations.organization);

    const payoutRatesOptions = payoutRates?.map(rate => {
        return {name: `${rate.label} - ${rate.currency.code} ${rate.amount}` , id: rate.id}
    })
    const pricingRatesOptions = pricingRates?.map(rate => {
        return {name: `${rate.label} - ${rate.currency.code} ${rate.amount}` , id: rate.id}
    })

    useEffect(() => {
        dispatch(payoutsActions.getAll())
        dispatch(pricingActions.getAll())
        if(organizationId){
            dispatch(scheduleActions.getSchedule(organizationId, scheduleId))
            dispatch(organizationActions.getOrganization(organizationId))
        }
    },[organizationId, dispatch])

    if ( currentScheduleLoading || payoutRatesLoading || pricingRatesLoading) return <Loading/>

    return(
        <Box sx={styles.root}>
            <Box sx={styles.container}>
                <Box component={"h1"} sx={styles.headingText}>Edit Schedule</Box>
                <EditScheduleForm
                    payoutRates={payoutRatesOptions}
                    pricingRates={pricingRatesOptions}
                    schedule={currentSchedule}
                    scheduleId={scheduleId}
                    orgId={organizationId}
                    organization={organization}
                />
            </Box>
        </Box>
    )
}

const styles = {
    root: {
        fontFamily: 'LarsseitRegular',
        letterSpacing: '-0.02em',
        color: '#0C2728',
        backgroundColor: '#EFEAE7',
        pt: 13,
        pb: 10,
        minHeight: '100vh',
    },
    container: {
        px: { xs: 2, sm: 6 },
        maxWidth: '1440px',
        position: 'relative',
    },
    headingText: {
        mb: 0,
        fontFamily: 'LarsseitMedium',
        fontSize: 24,
        lineHeight: 1.2,
        letterSpacing: '-0.02em',
        color: '#0C2728'
    }
}